import { useAppSelector } from "../../app/hooks";
import { UserRole } from "../../app/userSlice";
import StudentLessons from "./StudentLessons";
import { TeacherLessons } from "./TeacherLessons";

export default function Lessons() {
	const role = useAppSelector((state) => state.user.role);

	return role === UserRole.Writer ? <StudentLessons /> : <TeacherLessons />;
}
